import React from 'react'

import { TableBody, TableCell, TableRow } from '@material-ui/core'
import InputGroup from '../../../../../../../UI/Forms/InputGroup/InputGroup'

const Body = ({ rowData, rowInputChanged }) => {
  const tableRows = rowData.map(item => {
    const gradeKey = item.grade_id.value
    return <Row key={gradeKey} dataKey={gradeKey} data={item} inputChanged={rowInputChanged} />
  })
  return <TableBody>{tableRows}</TableBody>
}

const Row = ({ dataKey, data, inputChanged }) => {
  const tableColumns = Object.entries(data).map(item => {
    const [inputGroupKey, inputGroupAttrs] = item
    return (
      <Column
        key={inputGroupKey}
        gradeKey={dataKey}
        inputGroupKey={inputGroupKey}
        inputGroupAttrs={inputGroupAttrs}
        inputChanged={inputChanged}
      />
    )
  })
  return <TableRow>{tableColumns}</TableRow>
}

const Column = ({ inputGroupKey, gradeKey, inputGroupAttrs, inputChanged }) => {
  if (inputGroupAttrs.elementType === 'hidden') {
    return null
  }
  if (inputGroupAttrs.elementType === 'static') {
    return <TableCell align={'center'}>{inputGroupAttrs.value ?? ''}</TableCell>
  }
  return (
    <TableCell>
      <InputGroup
        key={inputGroupKey}
        label={inputGroupAttrs.label}
        inputType={inputGroupAttrs.elementType}
        configs={inputGroupAttrs.elementConfig}
        invalid={!inputGroupAttrs.valid}
        validations={inputGroupAttrs.validation}
        touched={inputGroupAttrs.touched}
        changed={e => inputChanged(gradeKey, inputGroupKey, { ...e })}
        inputValue={inputGroupAttrs.value}
        validationError={inputGroupAttrs.error}
      />
    </TableCell>
  )
}

export default Body
